import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/tributario/credenciamentoTipo/';

class CredenciamentoTipoService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllCredenciamentoTipo(idCliente) {
        return axios.get(API_URL + 'all?idCliente='+idCliente, {headers: this.headers});
    }
}

export default new CredenciamentoTipoService();